module.exports = __webpack_public_path__ + "knowledge.8qu6N88W.svg";